export default "__VITE_ASSET__0d9cdd7e__"